import React from 'react';

import { Wrapper, Top, Heading, ItemList, Item, Legend } from './List.styled';

export interface Props {
    id?: string;
    heading?: string;
    legend?: string;
    fieldset?: boolean;
    maxHeight?: boolean | string;
    children?: React.JSX.Element[];
}

const List: React.FC<Props> = props => {
    const { id, heading, fieldset = false, legend, maxHeight = false, children } = props;

    const showLegend = legend && fieldset;

    return (
        <Wrapper id={id} as={fieldset ? 'fieldset' : undefined}>
            {showLegend && <Legend>{legend}</Legend>}
            <Top>{!showLegend && heading && <Heading>{heading}</Heading>}</Top>
            <ItemList $maxHeight={maxHeight}>
                {children &&
                    React.Children.map(children, child => (
                        <Item className="c-list-block-list-item">{child}</Item>
                    ))}
            </ItemList>
        </Wrapper>
    );
};

export default List;
